module.exports = __webpack_public_path__ + "static/media/22ESCWA20.660490c7.jpg";